import PageHero from '@/components/feature/PageHero';

export default function ExperienceHero() {
  return (
    <PageHero
      eyebrow="体验九畴云市"
      title="让投资人，亲自体验项目"
      titleHighlight="五角色模拟运营环境"
      desc="选择一个角色，走进九畴云市的模拟运营环境，从「介绍项目」升级到「让投资人亲自体验项目」。"
      imageUrl="https://readdy.ai/api/search-image?query=Abstract%20immersive%20interactive%20experience%20entrance%20visualization%2C%20deep%20dark%20ink%20navy%20background%2C%20five%20glowing%20emerald%20and%20gold%20portal%20nodes%20representing%20different%20user%20roles%2C%20digital%20commerce%20simulation%2C%20futuristic%20rural%20economy%2C%20minimal%20geometric%20composition%2C%20cinematic%20lighting%2C%20high%20detail&width=1800&height=1100&seq=jiuchou-exp-01&orientation=landscape"
      imageAlt="体验九畴云市 五角色模拟运营环境"
      imageTitle="体验九畴云市"
    />
  );
}